import React from 'react'
import './PageTitle.scss'
import { Link } from 'react-router-dom'

export default function PageTitle({ mainTitle, page }) {
  return (
    <div className='pageTitlePage'>
      <div className="container">
        <div className="row">
          <div className="left">
          </div>
          <h1 className="text">
            {mainTitle}
          </h1>
          <div className="right">
          </div>
          <div className="map">
            <Link to='/'><span>HOME</span></Link> &gt; <span>{page}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
